<script setup lang="ts">
defineProps<{
  title: string,
}>();
</script>

<template>
  <h2 class="text-sm text-(--color-sidebar-text)">
    {{ title }}
  </h2>
</template>
